//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.span`
    color: var(--light-gray-2);
    font-weight: bold;
    font-size: 12px;
`;